'use client'

import MapboxPolygon from '@component/mapbox/layer/polygon'
import { useEstimateMapContext } from '../../context'
import { useMemo } from 'react'
import { get, size } from 'lodash-es'

export default function DetailPolygon() {

  const { hoverDetailData } = useEstimateMapContext()
  const boundaries = useMemo(() => get(hoverDetailData, '0.boundaries'), [hoverDetailData])

  return size(boundaries) > 0 && (
    <MapboxPolygon paths={boundaries}></MapboxPolygon>
  )
}